import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function MillingHubLayout() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const menu = [
    { key: ROUTES.MILLING.MILLING_HUB_DASHBOARD, label: "Dashboard",   icon: "bi bi-speedometer", iconImage: '' },
    { key: ROUTES.MILLING.MILLING_AddMachine, label: "AddMachine", icon: "bi-cash-stack", iconImage: '' },
    { key: ROUTES.MILLING.MILLING_Report, label: "Milling Report", icon: "bi-file-earmark-text-fill", iconImage: '' },
 {
    key: ROUTES.MILLING.MillingCompleteOrder,
    label: "Complete Order",
    icon: "bi-patch-check-fill",
    iconImage: ""
  },
  ];

  
  const menuGroups = [
    {
      title: "Master",
      icon: "bi-collection-fill",
      items: [
        {
          key: ROUTES.MILLING.Settings.officetimings,
          label: "Office Timings",
          icon: "bi-clock-history",
          iconImage: ''
        },
      ]
    }
  ];

  return (
    <GenericLayout
      menu={menu}
      menuGroups={menuGroups}
      titleLabel="Milling Hub"
      profileRoute={ROUTES.MILLING.MILLING_PROFILE}
      showNotifications={true}
      apiNotificationUrl={`${API_BASE}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
